import { alpha, type SxProps, type Theme } from "@mui/material/styles";
export const group: SxProps<Theme> = { display: "flex", flexDirection: "column", gap: 1.25 };
export const title: SxProps<Theme> = {
  fontSize: { xs: ".75rem", md: ".8125rem" },
  fontWeight: 700,
};
export const option =
  (checked: boolean): SxProps<Theme> =>
  (theme) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    p: { xs: 1.5, md: 1.75 },
    border: 1.5,
    borderColor: checked ? "primary.main" : "divider",
    borderRadius: 1.75,
    bgcolor: checked ? alpha(theme.palette.primary.main, 0.06) : "transparent",
    cursor: "pointer",
  });
export const grow: SxProps<Theme> = { flex: 1 };
export const optionTitle: SxProps<Theme> = {
  fontSize: { xs: ".78125rem", md: ".84375rem" },
  fontWeight: 600,
};
export const description: SxProps<Theme> = {
  fontSize: { xs: ".6875rem", md: ".75rem" },
  color: "text.secondary",
};
export const divider: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 1.25,
  borderTop: 1,
  borderColor: "divider",
  pt: { xs: 1.75, md: 2.25 },
};
export const sms: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1.25,
};
